import { useAppMetaContent } from '../../../state-management/providers/AppMetaContentProvider'

const shieldIconUrl = '/images/new-elite/stats/sebi.svg'
const usersIconUrl = '/images/new-elite/stats/user.svg'
const rupeeIconUrl = '/images/new-elite/stats/aum.svg'

export type TrustMetric = {
  value: string
  label: string
  iconUrl: string
  iconClassName?: string
}

type NewEliteLandingTrustMetricsProps = {
  metrics?: TrustMetric[]
  className?: string
  hideIcons?: boolean
  showDividers?: boolean
  valueClassName?: string
  labelClassName?: string
}

export default function NewEliteLandingTrustMetrics({
  metrics,
  className = 'pt-4 mt-5 mb-8',
  hideIcons = false,
  showDividers = false,
  valueClassName = 'text-[#65321D]',
  labelClassName = 'text-[rgba(101,50,29,0.53)]'
}: NewEliteLandingTrustMetricsProps) {
  const { getEliteMembersDisplay, getAumTrackedDisplay } = useAppMetaContent()
  const eliteMembersDisplay = getEliteMembersDisplay('long') ?? ''
  const aumTrackedDisplay = getAumTrackedDisplay('long') ?? ''
  // Caller-supplied metrics (e.g. elite-plans CMS) win; AppMeta only fills defaults
  const resolvedMetrics = metrics ?? [
    {
      value: 'SEBI',
      label: 'Registered',
      iconUrl: shieldIconUrl,
      iconClassName: 'size-[18px]'
    },
    {
      value: eliteMembersDisplay,
      label: 'Elite users',
      iconUrl: usersIconUrl,
      iconClassName: 'size-[18px]'
    },
    {
      value: aumTrackedDisplay,
      label: 'Elite AUM',
      iconUrl: rupeeIconUrl,
      iconClassName: 'size-[18px]'
    }
  ]

  return (
    <div className={className}>
      <ul className={`m-0 flex list-none items-stretch justify-center p-0 ${showDividers ? 'gap-5' : 'gap-9'}`}>
        {resolvedMetrics.map((metric, metricIndex) => (
          <li key={`${metric.value}-${metric.label}`} className='flex items-stretch gap-5'>
            {/* Divider lives inside the li so the ul keeps only li children */}
            {showDividers && metricIndex > 0 ? (
              <span aria-hidden='true' className='w-px shrink-0 self-stretch bg-[color:var(--ep-metric-divider,theme(colors.elite70))] opacity-20' />
            ) : null}
            <div className='flex min-w-[72px] flex-col items-center justify-center gap-1.5'>
              {hideIcons ? null : (
                <img
                  alt=''
                  src={metric.iconUrl}
                  className={`${metric.iconClassName ?? 'size-[18px]'} object-contain`}
                  aria-hidden='true'
                />
              )}
              <div className='text-center leading-[1.4]'>
                <p className={`text-[13px] font-medium ${valueClassName}`}>{metric.value}</p>
                <p className={`text-[13px] font-normal ${labelClassName}`}>{metric.label}</p>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  )
}
